<template>
  <div>
    <div class="overline">
      {{ title }}
    </div>
    <ul>
      <li v-for="(item, index) in items" :key="index">
        <!-- {{ item.strength }} {{ item.name }} -->
        <span v-if="item[key1]">{{ concToPercent(item[key1]) }}</span>
        <span v-if="item[key2]"> {{ item[key2] }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
// import MoreDetailsDialog from './MoreDetailsDialog.vue';
// import Name from "../dir/file";
import ConcToPercentMixin from "@/assets/js/meds/ConcToPercentMixin";

export default {
  components: {},
  mixins: [ConcToPercentMixin],
  name: "MedItemList",
  props: {
    items: null,
    title: null,
    key1: null,
    key2: null,
    showDialog: {
      default: true,
      type: Boolean,
    },
  },
  data: function () {
    return {};
  },
  methods: {},
  computed: {},
};
</script>

<style scoped></style>
